export default ({ Factory }) => ({

  /**
   * Создание комментария
   * @param {Object} comment - комментарий
   */
  create: (comment) => Factory.post(comment),

  /**
   * Обновление комментария
   * @param {Object} comment - комментарий
   */
  update: (comment) => Factory.put(comment),

  /**
   * Удаление комментария
   * @param {String} id - идентификатор комментария
   */
  remove: (id) => Factory[id].delete(),

  /**
   * Лайк комментария
   * @param {String} id - идентификатор комментария
   */
  like: (id) => Factory[id].like.post(),

  /**
   * Дизлайк комментария
   * @param {String} id - идентификатор комментария
   */
  dislike: (id) => Factory[id].dislike.post(),

  /**
   * Получение списка комментариев
   * @param {String} publication - идентификатор публикации
   * @param {Number} start - начало списка
   * @param {Number} page - страница списка
   * @param {String} last_id - идентификатор последнего комментария
   */
  list: (publication, start, page, last_id) => {
    let params = `?publication=${publication}&start=${start}&page=${page}`
    if (last_id)
      params += '&last_id=' + last_id
    return Factory.list[params].get()
  }
})